import { Col, FlexibleDiv } from '@components/formStyles';

import { TourCardText } from './styled';

interface Props {
  label: string;
  date: string;
  description?: string;
}

const TourDateItem = ({ label, date, description }: Props) => {
  return (
    <Col>
      <FlexibleDiv bottom={10}>
        <TourCardText size={18} weight='bold'>
          {label}
        </TourCardText>
      </FlexibleDiv>

      <FlexibleDiv bottom={10}>
        <TourCardText size={16} weight={600}>
          {date}
        </TourCardText>
      </FlexibleDiv>

      <TourCardText size={16} weight='normal'>
        {description}
      </TourCardText>
    </Col>
  );
};

export default TourDateItem;
